import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subject, takeUntil } from 'rxjs';
import { ViewportService } from 'app/services/viewport.service';

export class RealEstateItem {
    slides: { id: string; imageUrl: string; title: string }[];
    i18nTitleKey: string;
    i18nDescriptionKey: string;
    backgroundImage: string;
    points: {
        imageUrl: string;
        i18nKeyTitle: string;
        i18nDescription: string;
    }[];
    layout: 'image-right' | 'image-left';
}

@Component({
    selector: 'app-real-estate-card',
    templateUrl: './real-estate-card.component.html',
    styleUrls: ['./real-estate-card.component.scss'],
})
export class RealEstateCardComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    public mobile: boolean = false;
    @Input() item: RealEstateItem;

    constructor(private viewport: ViewportService) {}

    ngOnInit(): void {
        this.viewport.isMobile$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((mobile) => (this.mobile = mobile));
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
